
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

interface UserDialogsProps {
  errorDialogOpen: boolean;
  setErrorDialogOpen: (open: boolean) => void;
  errorMessage: string;
  deleteDialogOpen: boolean;
  setDeleteDialogOpen: (open: boolean) => void;
  confirmDeleteUser: () => void;
  successDialogOpen?: boolean;
  setSuccessDialogOpen?: (open: boolean) => void;
  successMessage?: string;
}

export const UserDialogs = ({
  errorDialogOpen,
  setErrorDialogOpen,
  errorMessage,
  deleteDialogOpen,
  setDeleteDialogOpen,
  confirmDeleteUser,
  successDialogOpen,
  setSuccessDialogOpen,
  successMessage
}: UserDialogsProps) => {
  return (
    <>
      <AlertDialog open={errorDialogOpen} onOpenChange={setErrorDialogOpen}>
        <AlertDialogContent className="bg-secondary border border-red-500/30 text-primary-light">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-red-500">Error Creating User</AlertDialogTitle>
            <AlertDialogDescription className="text-primary-light">
              {errorMessage}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction className="bg-primary hover:bg-primary/90 text-black">
              Close
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog open={deleteDialogOpen} onOpenChange={setDeleteDialogOpen}>
        <AlertDialogContent className="bg-secondary border border-red-500/30 text-primary-light">
          <AlertDialogHeader>
            <AlertDialogTitle className="text-red-500">Confirm User Deletion</AlertDialogTitle>
            <AlertDialogDescription className="text-primary-light">
              Are you sure you want to delete this user? This action cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="border-primary/20 text-black bg-white">
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction onClick={confirmDeleteUser} className="bg-red-500 hover:bg-red-600 text-white">
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {successDialogOpen && setSuccessDialogOpen && (
        <AlertDialog open={successDialogOpen} onOpenChange={setSuccessDialogOpen}>
          <AlertDialogContent className="bg-secondary border border-green-500/30 text-primary-light">
            <AlertDialogHeader>
              <AlertDialogTitle className="text-green-500">Success</AlertDialogTitle>
              <AlertDialogDescription className="text-primary-light">
                {successMessage}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogAction className="bg-primary hover:bg-primary/90 text-black">
                Close
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
    </>
  );
};
